import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';
import { paginationHelper } from 'utils/helper';

function* fetchFavouriteArticles({ params, callbacks }) {
  try {
    const response = yield call(api.fetchArticles, params);
    const data = response?.data;
    const pagination = paginationHelper(response?.headers);

    yield put(Actions.fetchFavouriteArticlesSuccess(data, pagination));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success, response.data);
    }
  } catch (error) {
    yield put(Actions.fetchFavouriteArticlesFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

function* watchFetchFavouriteArticles() {
  yield takeLatest(
    Actions.FETCH_FAVOURITE_ARTICLES_REQUEST,
    fetchFavouriteArticles
  );
}

export default function* favouriteList() {
  yield all([fork(watchFetchFavouriteArticles)]);
}
